import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { editAgents } from "../../../RTK/agents/EditAgents";
// import { updateAgent } from "../../../RTK/agents/GetAgents";

const EditAgentModal = ({ agentDetails, onSave }) => {
  const [formData, setFormData] = useState({
    name: agentDetails.name || "",
    agent_balance: agentDetails.agent_balance || "",
    contact_email: agentDetails.contact_email || "",
    website: agentDetails.website || "",
    api_url: agentDetails.api_url || "",
    api_token: agentDetails.api_token || "",
    channel: agentDetails.channel || "",
  });
  const [isVisible, setIsVisible] = useState(true); // Modal visibility state
  const [loading, setLoading] = useState(false); // Loading state for the Save button

  const dispatch = useDispatch();

  useEffect(() => {
    setFormData({
      name: agentDetails.name || "",
      agent_balance: agentDetails.agent_balance || "",
      contact_email: agentDetails.contact_email || "",
      website: agentDetails.website || "",
      api_url: agentDetails.api_url || "",
      api_token: agentDetails.api_token || "",
      channel: agentDetails.channel || "",
    });
  }, [agentDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleClose = () => {
    setIsVisible(false); // Hide the modal
  };

  const handleSubmit = async () => {
    setLoading(true); // Set loading state to true
    try {
      // Create the update data object
      const updateData = {
        id: agentDetails.id,
        updatedAgentData: formData,
      };

      // Dispatch update agent action with formData
      await dispatch(editAgents(updateData)).unwrap();

      toast.success("Agent updated successfully!");
      onSave(formData); // Pass updated data to parent modal
      handleClose(); // Close the edit modal
    } catch (error) {
      toast.error(error || "Failed to update agent. Please try again.");
    } finally {
      setLoading(false); // Set loading state to false
    }
  };

  const labelMap = {
    name: " الاسم ",
    agent_balance: "الرصيد ",
    contact_email: "الايميل",
    website: "الموقع",
    api_url: "API URL",
    api_token: "API Token",
    channel: " Channel",
  };

  const formatFieldLabel = (key) => {
    // Check if the key has a custom label, if not fallback to the default formatting
    return (
      labelMap[key] ||
      key
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    );
  };

  if (!isVisible) return null; // Don't render if the modal is not visible

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[7000] bg-black/90 backdrop-blur">
      <div className="bg-white/10 backdrop-blur-lg rounded-xl z-[7500] overflow-hidden border border-white/10 w-[90%] max-w-lg">
        {/* Header */}
        <div className="p-6 border-b border-white/10 relative flex items-center justify-between">
          <div className="flex-grow">
            {" "}
            {/* Use flex-grow to make this container take available space */}
            <h3 className="text-lg font-bold mb-1 text-left">
              تعديل الوكيل
            </h3>{" "}
            {/* Add text-left for explicit alignment */}
          </div>

          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>
        </div>

        {/* Form content */}
        <div className="p-6 space-y-6">
          <div className="space-y-3">
            {Object.keys(formData).map((key) => (
              <div key={key} className="flex  gap-2 justify-between">
                <label className="text-sm text-gray-300 mx-8">
                  {formatFieldLabel(key)}
                </label>
                <input
                  type={key === "contact_email" ? "email" : "text"}
                  name={key}
                  value={formData[key]}
                  onChange={handleChange}
                  className="bg-white/5 text-white rounded-lg p-2 max-w-[200px] sm:w-[300px] lg:max-w-[400px] border border-white/10 focus:border-blue-500 focus:outline-none"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-4 p-6 border-t border-white/10">
          <button
            onClick={handleClose}
            className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className={`px-4 py-2 rounded-lg text-white transition-colors ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            }`}
            disabled={loading}
          >
            {loading ? "Saving...!" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditAgentModal;
